import { DOMAIN, PERMISSION } from "@/hooks/useCapabilities";
import { NavLink } from "@/layouts/AppLayout/types";
import { Path } from "@/router";
import type { Capability } from "@/providers/AuthorizationProvider";

export const GRP_TAB_ITEMS: { label: string; to: Path; permission: PERMISSION }[] = [
  { label: "Enrollments", to: "/billing/finance/grp/enrollments", permission: PERMISSION.viewGrpEnrollments },
  {
    label: "Member Contributions",
    to: "/billing/finance/grp/member-contributions",
    permission: PERMISSION.viewMemberContributions
  },
  {
    label: "Sponsor Contributions",
    to: "/billing/finance/grp/sponsor-contributions",
    permission: PERMISSION.viewSponsorContributions
  }
];

export const canViewGrpTab = (capabilities: Capability, permission: PERMISSION): boolean =>
  capabilities.domains.includes(DOMAIN.BENEFIT_PROGRAMS) && capabilities.permissions.includes(permission);

export const getVisibleGrpTabs = (capabilities: Capability) =>
  GRP_TAB_ITEMS.filter((tab) => canViewGrpTab(capabilities, tab.permission));

export const getGrpHomePath = (capabilities: Capability): Path => {
  if (canViewGrpTab(capabilities, PERMISSION.viewMemberContributions)) {
    return "/billing/finance/grp/member-contributions";
  }

  return getVisibleGrpTabs(capabilities)[0]?.to ?? "/";
};

export const getGrpNavLinks = (): NavLink<Path>[] => [
  {
    domain: DOMAIN.BENEFIT_PROGRAMS,
    label: "Contributions",
    link: { to: "/billing/finance/grp" },
    icon: "settings"
  },
  {
    domain: DOMAIN.BENEFIT_PROGRAMS,
    label: "All Finance",
    link: { to: "/billing/finance" },
    icon: "card_membership",
    trailingIcon: "navigate_next",
    dividerBefore: true,
    externalLink: true
  }
];
